import React, { forwardRef } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { ExtensionKey, TicketKey } from 'flow/types/EntityKeys';
import {
    selectMembers,
    selectNonMembersAreMentionable,
} from 'flow/selectors/TicketsSelectors';
import MentionPicker, { MentionPickerHandle } from './MentionPicker';

interface Props {
    ticketKey: TicketKey;
    text: string;
    onSelect: (name: string, extensionKey?: ExtensionKey) => void;
    onCloseRequested: () => void;
}

const TicketMentionPicker = forwardRef<MentionPickerHandle, Props>(
    ({ ticketKey, text, onSelect, onCloseRequested }, ref) => {
        const memberKeys = useAppSelector((state) =>
            selectMembers(state, ticketKey),
        );
        const nonMembersAreMentionable = useAppSelector((state) =>
            selectNonMembersAreMentionable(state, ticketKey),
        );

        return (
            <MentionPicker
                ref={ref}
                memberKeys={memberKeys}
                nonMembersAreMentionable={nonMembersAreMentionable}
                text={text}
                onSelect={onSelect}
                onCloseRequested={onCloseRequested}
            />
        );
    },
);

TicketMentionPicker.displayName = 'TicketMentionPicker';

export default React.memo(TicketMentionPicker);
